import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, {
  useId,
  useMemo
} from 'react';

/**
 * @param id En caso de existir mas de un accordeon el id del padre debe ser
 *     entregado a cada hijo en el @param idParent
*/

export function Accordeon({
  id: defaultId,
  className,
  children
}) {
  const automaticId = useId();
  const id = useMemo(() => {
    return defaultId || automaticId.replaceAll(':', '-');
  }, [automaticId, defaultId]);
  const childrenWithRef = React.Children.map(children, (child) => {
    return React.cloneElement(child, { acordeonId: id });
  });
  return (
    <div className={classNames('accordion', className)} id={id}>
      {childrenWithRef}
    </div>
  );
}

Accordeon.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Accordeon;
